<template>
    <main id="mainCtrl">


        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li
                    :class="{'active': getActiveTab('mod')}"
                    @click="activateTab('mod')"
                    id="tabNew"
                ><a href="#">Модерация</a>
                </li>
                <li
                    :class="{'active': getActiveTab('pub')}"
                    @click="activateTab('pub')"
                    id="tabApproved"
                ><a href="#">Опубликованные</a>
                </li>
            </ul>
        </div>

        <ModList v-if="getActiveTab('mod')"/>
        <PublishedList v-if="getActiveTab('pub')"/>
    </main>
</template>
<script>
import ModList from "./ModList.vue";
import PublishedList from "./PublishedList.vue";

export default {
    components: {ModList, PublishedList},
    data(){
        return {
            tabs:{
                mod:{active:true},
                pub:{active:false}
            }
        }
    },
    methods: {
        getActiveTab(key){
            return this.tabs[key].active
        },
        activateTab(key){
            for (let tabKey in this.tabs){
                this.tabs[tabKey].active = false
            }

            this.tabs[key].active = true
        }
    }
}

</script>
<style>

</style>
